import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";

export const scrollTo = (e, href) => {
  e.preventDefault();
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -90, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

const Navbar = () => {
  const [onHero, setOnHero] = useState(true);
  const { scrollY } = useScroll();
  useMotionValueEvent(scrollY, "change", (y) => {
    const hero = document.getElementById("top");
    const reveal = document.querySelector("[data-testid='scissors-section']");
    const redEnd = (hero?.offsetHeight || 0) + (reveal?.offsetHeight || 0);
    const limit = redEnd ? redEnd - 48 : 600;
    setOnHero(y < limit);
  });

  const tone = onHero ? "text-[#F7F2EC] drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)]" : "text-[#0B1F3A]";

  return (
    <motion.nav
      data-testid="bany-navbar"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      style={{ x: "-50%" }}
      className={`fixed top-5 left-1/2 z-50 flex items-center transition-colors duration-500 ${tone}`}
    >
      <a href="#top" onClick={(e) => scrollTo(e, "#top")} className="flex items-baseline gap-2" data-testid="nav-logo">
        <span className="font-display font-black tracking-tight text-2xl leading-none">BANY</span>
        <span className="text-[10px] tracking-[0.35em] font-mono-alt uppercase opacity-80">Barbershop</span>
      </a>
    </motion.nav>
  );
};

export default Navbar;
